import { render, staticRenderFns } from "./newCriteriaTypeDialog.vue?vue&type=template&id=7d4ddbfc&"
import script from "./newCriteriaTypeDialog.vue?vue&type=script&lang=js&"
export * from "./newCriteriaTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4ddbfc')) {
      api.createRecord('7d4ddbfc', component.options)
    } else {
      api.reload('7d4ddbfc', component.options)
    }
    module.hot.accept("./newCriteriaTypeDialog.vue?vue&type=template&id=7d4ddbfc&", function () {
      api.rerender('7d4ddbfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftList/components/newCriteriaTypeDialog.vue"
export default component.exports